import CLIENT from '../../../store/actions/CLIENT';
import {
  OTP_SEND,
  LOGIN_EMAIL,
  LOGIN_ERROR,
  VERIFY_CODE,
  CODE_VERIFICATION_ERROR,
  CODE_VERIFIED,
  RESET_USER,
  SELF_LOGIN_ERROR,
  SELF_LOGIN,
  SET_APP_VERSION,
} from './types';

export const LoginUser = (payload) => async (dispatch, getState) => {
  dispatch({ type: LOGIN_EMAIL, payload });
  return CLIENT({
    // Bhartesh : Move this variable to .env file
    url: '/api/Login',
    state: getState(),
    body: {
      email: payload.email,
    },
  })
    .then((response) => {
      return dispatch({
        type: OTP_SEND,
        payload: response.data,
      });
    })
    .catch((error) => {
      return dispatch({
        type: LOGIN_ERROR,
        error,
      });
    });
};

export const VerifyCode = (payload) => async (dispatch, getState) => {
  dispatch({ type: VERIFY_CODE });
  return CLIENT({
    url: '/api/verifyUser',
    state: getState(),
    body: {
      email: getState().auth.data.email,
      code: payload.code,
    },
  })
    .then((response) => {
      return dispatch({
        type: CODE_VERIFIED,
        payload: response.data,
      });
    })
    .catch((error) => {
      return dispatch({
        type: CODE_VERIFICATION_ERROR,
        error,
      });
    });
};

export const SelfAuthUser = (payload) => async (dispatch, getState) => {
  return CLIENT({
    url: '/api/selfAuth',
    state: getState(),
    body: {
      token: payload.token,
    },
  })
    .then((response) => {
      return dispatch({
        type: SELF_LOGIN,
        payload: response.data,
      });
    })
    .catch((error) => {
      return dispatch({
        type: SELF_LOGIN_ERROR,
        error,
      });
    });
};

export const ResetUser = () => (dispatch) => {
  return dispatch({ type: RESET_USER });
};

export const setAppVersion = (payload) => (dispatch) => {
  return dispatch({ type: SET_APP_VERSION, payload });
}
